export enum ActionMenuItem {
  Delete = 'delete',
  Download = 'download',
  Uploads = 'uploads',
}
